import type { QueryClient } from "@tanstack/react-query";

export function invalidateHolidayQueries(queryClient: QueryClient) {
	queryClient.invalidateQueries({ queryKey: ["holidays"] });
	queryClient.invalidateQueries({ queryKey: ["time-entries"] });
	queryClient.invalidateQueries({ queryKey: ["timesheet"] });
}
